import React from 'react';
import Select from 'react-select';
import cn from 'classnames';
import styles from './style.scss';

export function CheckoutSession({ session, onDisconnect, settings, onCardSelection }) {
  const isMobile = window.isMobileType;

  const selectStyles = {
    container: (base) => ({
      ...base,
      zIndex: 9999,
    }),
    menuPortal: (base) => ({
      ...base,
      zIndex: 9999,
    }),
  };
  const cards = session.cards.map((card) => ({
    value: card.id,
    label: `${card.card_brand} ${card.last_4}`,
  }));
  return (
    <div>
      <div className={cn('fast-checkout-header', styles.sessionWelcomeText)}>
        {settings.get('welcomeCheckoutText')} {session.attendee.first_name}
      </div>
      <div className={cn({ [styles.mobileCardSelectionContainer]: isMobile, [styles.cardSelectionContainer]: !isMobile })}>
        <div className="fast-checkout-card-selection-text">{settings.get('selectCardText')}</div>
        <Select
          styles={selectStyles}
          menuPortalTarget={document.body}
          defaultValue={cards[0]}
          options={cards}
          className={styles.cardSelection}
          onChange={onCardSelection}
        />
        <div className={cn('fast-checkout-card-logout', styles.disconnect)} onClick={onDisconnect}>
          {settings.get('disconnectSessionText')}
        </div>
      </div>
    </div>
  );
}
